module.exports = __webpack_public_path__ + "static/media/sf-test-1.17708d04.mp3";